import { Action, Dispatch } from 'redux'
import { db, FirebaseTimestamp } from 'firebase/index'
import { TagType } from 'types/tag'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { push } from 'connected-react-router'

const saveTag = (name: string, isPublished: boolean, id: string | undefined) => {
  return async (dispatch: Dispatch<Action>) => {
    const now = FirebaseTimestamp.now()
    const value: TagType = {
      id: id ?? '',
      is_deleted: false,
      is_published: isPublished,
      name: name,
      updated_at: now,
    }

    if (value.id === '') {
      const ref = db.collection('tags').doc()
      value.id = ref.id
      value.created_at = now
    }

    dispatch(showLoadingAction())

    return db
      .collection('tags')
      .doc(value.id)
      .set(value, { merge: true })
      .then(() => {
        dispatch(hideLoadingAction())
        dispatch(push('/admin/master/tags'))
      })
      .catch((error) => {
        dispatch(hideLoadingAction())
        console.error(error)
      })
  }
}

export default saveTag
